import axiosInstance from './axiosInstance';
import { API_PATH, API_VERSION } from './constants';

const channelService = {
    getChannels : (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CHANNELS}`)
    },
    addOrRemoveSelectedChannel: (companyId,channelId,addRemove) => 
    {
        return axiosInstance.put(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CHANNELS}/${channelId}/${addRemove}`)
    },
}

export default channelService;
